import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from '@sm/wds-react';
import {
  getProductsLinks,
  getSolutionsLinks,
  getResourcesLinks
} from './navSubmenuListItems';

const renderLink = linksData => {
  return (
    <Button
      size="sm"
      color="link"
      variant="text"
      className={`sm-nav-submenu__button wds-float--${linksData.alignment}`}
      href={linksData.url}
    >
      {linksData.title}
      <Icon>]</Icon>
    </Button>
  );
};

/**
 * Render bottom links in submenus
 * @param {string} submenuKey
 * @param {string} lang
 * @return {*}
 * @constructor
 */
export const NavSubmenuBottomLinks = ({ submenuKey, lang }) => {
  const linksData =
    {
      Products: getProductsLinks(lang),
      Solutions: getSolutionsLinks(lang)
    }[submenuKey] || getResourcesLinks(lang);

  return (
    <If condition={linksData.length > 0}>
      <div
        className={`sm-nav-submenu__bottom-container sm-nav-submenu--${lang}`}
      >
        {linksData[0] && renderLink(linksData[0])}
        {linksData[1] && renderLink(linksData[1])}
      </div>
    </If>
  );
};

NavSubmenuBottomLinks.propTypes = {
  submenuKey: PropTypes.string,
  lang: PropTypes.string
};

NavSubmenuBottomLinks.defaultProps = {
  submenuKey: 'Products',
  lang: 'en'
};

export default NavSubmenuBottomLinks;
